"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronRight, X } from "lucide-react";
import type { BreadcrumbItem } from "./entry-drawer-types";
interface EntryDrawerHeaderProps {
  breadcrumbs: BreadcrumbItem[];
  entryName: string;
  onSelectEntry?: (entryId: string) => void;
  onClose: () => void | Promise<void>;
}
export function EntryDrawerHeader(t0) {
  const $ = _c(14);
  const {
    breadcrumbs,
    entryName,
    onSelectEntry,
    onClose
  } = t0;
  let t1;
  if ($[0] !== breadcrumbs || $[1] !== onSelectEntry) {
    t1 = breadcrumbs.length > 0 && <>{breadcrumbs.map(crumb => <span key={crumb.id} className="flex items-center gap-1 shrink-0"><button onClick={() => onSelectEntry?.(crumb.id)} className="text-xs text-muted-foreground hover:text-primary transition-colors truncate max-w-[100px]" title={crumb.name}>{crumb.name}</button><ChevronRight className="h-2.5 w-2.5 text-muted-foreground/50 shrink-0" /></span>)}</>;
    $[0] = breadcrumbs;
    $[1] = onSelectEntry;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== entryName) {
    t2 = <h3 className="text-sm font-semibold truncate">{entryName}</h3>;
    $[3] = entryName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-center gap-1 min-w-0 flex-1 overflow-x-auto">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <X className="h-4 w-4" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClose) {
    t5 = <button onClick={onClose} aria-label="Close entry editor" className="ml-2 flex h-9 w-9 shrink-0 items-center justify-center rounded transition-colors hover:bg-accent sm:h-6 sm:w-6">{t4}</button>;
    $[9] = onClose;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="border-b border-border px-4 py-2 shrink-0"><div className="flex items-center justify-between">{t3}{t5}</div></div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}